import { validStyles, stylePropsTextOnly } from "@tamagui/core";
import { getVariableValue, isWeb } from "@tamagui/core";
import { getButtonSized } from "@tamagui/get-button-sized";
import { getFontSized } from "@tamagui/get-font-sized";
import { getSpace } from "@tamagui/get-token";
const defaultStyles = {
    size: "$true",
    fontFamily: "$body",
    borderWidth: 1,
    outlineWidth: 0,
    color: "$color",
    ...(isWeb ? {
      tabIndex: 0
    } : {
      focusable: !0
    }),
    borderColor: "$borderColor",
    backgroundColor: "$background",
    // this fixes a flex bug where it overflows container
    minWidth: 0,
    hoverStyle: {
      borderColor: "$borderColorHover"
    },
    focusStyle: {
      borderColor: "$borderColorFocus"
    },
    focusVisibleStyle: {
      outlineColor: "$outlineColor",
      outlineWidth: 2,
      outlineStyle: "solid"
    }
  },
  inputSizeVariant = (val = "$true", extras) => {
    if (extras.props.multiline || extras.props.numberOfLines > 1) return textAreaSizeVariant(val, extras);
    const buttonStyles = getButtonSized(val, extras),
      paddingHorizontal = getSpace(val, {
        shift: -1,
        bounds: [2]
      }),
      fontStyle = getFontSized(val, extras);
    return !isWeb && fontStyle && delete fontStyle.lineHeight, {
      ...fontStyle,
      ...buttonStyles,
      paddingHorizontal
    };
  },
  textAreaSizeVariant = (val = "$true", extras) => {
    const {
        props
      } = extras,
      buttonStyles = getButtonSized(val, extras),
      fontStyle = getFontSized(val, extras),
      lines = props.rows ?? props.numberOfLines,
      height = typeof lines == "number" ? lines * getVariableValue(fontStyle.lineHeight) : "auto",
      paddingVertical = getSpace(val, {
        shift: -2,
        bounds: [2]
      }),
      paddingHorizontal = getSpace(val, {
        shift: -1,
        bounds: [2]
      });
    return {
      ...buttonStyles,
      ...fontStyle,
      paddingVertical,
      paddingHorizontal,
      height
    };
  },
  INPUT_NAME = "Input",
  styledBody = [{
    name: INPUT_NAME,
    tag: "input",
    variants: {
      unstyled: {
        false: defaultStyles
      },
      size: {
        "...size": inputSizeVariant
      },
      disabled: {
        true: {}
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }, {
    isInput: !0,
    accept: {
      placeholderTextColor: "color",
      selectionColor: "color"
    },
    validStyles: {
      ...validStyles,
      ...stylePropsTextOnly
    }
  }];
export { INPUT_NAME, defaultStyles, inputSizeVariant, styledBody, textAreaSizeVariant };
//# sourceMappingURL=shared.mjs.map
